import React from 'react'
import styles from './MainHeader.module.css'
import { APP_CONFIG } from '@/constants'

interface MainHeaderProps {
  onMenuToggle: () => void
}

const SearchIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
)

const MainHeader: React.FC<MainHeaderProps> = ({ onMenuToggle }) => {
  return (
    <header className={styles.mainHeader} role="banner">
      <div className={styles.mainHeader__inner}>
        {/* Logo — Authentic Dr Lal PathLabs cropped logo + Nextgen Health Care partnership */}
        <a
          href="/"
          className={styles.logoLink}
          aria-label={`${APP_CONFIG.name} — Authorized Collection Center Dr Lal PathLabs`}
        >
          <div className={styles.logoCard}>
            <img
              src="/assets/lalpathlabs-logo-white.png"
              alt="Dr Lal PathLabs"
              className={styles.logoImg}
            />
          </div>
          <div className={styles.partnerInfo}>
            <span className={styles.partnerTag}>Authorized Collection Center</span>
            <span className={styles.partnerName}>Nextgen Health Care</span>
          </div>
        </a>

        {/* Search Bar */}
        <div className={styles.searchBar} role="search">
          <label htmlFor="test-search" className="sr-only">Search for tests and packages</label>
          <input
            id="test-search"
            type="text"
            placeholder="Search Tests &amp; Packages..."
            className={styles.searchBar__input}
            autoComplete="off"
          />
          <button className={styles.searchBar__btn} aria-label="Search">
            <SearchIcon />
          </button>
        </div>

        {/* CTA + Hamburger */}
        <div className={styles.actions}>
          <button className={styles.bookBtn} aria-label="Book home collection">
            📋 Book Home Collection
          </button>
          <button
            className={styles.hamburger}
            onClick={onMenuToggle}
            aria-label="Open navigation menu"
            aria-expanded="false"
          >
            <span className={styles.hamburger__bar} />
            <span className={styles.hamburger__bar} />
            <span className={styles.hamburger__bar} />
          </button>
        </div>
      </div>
    </header>
  )
}

export default MainHeader

